import { useClientId, useCopyPasteStyles, useDeviceType } from "@blocks/hooks";
import { Fragment } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { EditProps } from "blocks/types";
import classnames from "classnames";
import React from "react";
import { useBlockStyle } from "../../hooks";

import InspectorControls from "./components/InspectorControls";

const Edit: React.ComponentType<EditProps<any>> = (props) => {
	const {
		className,
		attributes: {
			label,
			text,
			cssID,
			markup,
			typography,
			size,
			hideOnDesktop,
		},
		setAttributes,
	} = props;

	const { clientId } = useClientId(props);
	const { deviceType } = useDeviceType();
	const { CopyPasterStyleBlockControl } = useCopyPasteStyles();
	const { Style } = useBlockStyle({
		blockName: "post-content",
		clientId,
		attributes: props.attributes,
		deviceType,
	});

	const classNames = classnames(
		`mzb-post-content-block mzb-post-content-${clientId}`,
		className,
		typography?._className,
		hideOnDesktop && "magazine-blocks-hide-on-desktop"
	);

	return (
		<Fragment>
			<InspectorControls
				attributes={props.attributes}
				setAttributes={setAttributes}
			/>
			<CopyPasterStyleBlockControl withBlockControls />
			<Style />
			<div className={classNames}>
				<p>
					Lorem ipsum dolor sit amet, consectetur adipiscing elit. In
					eget faucibus enim. Vivamus ac dui euismod velit convallis
					consequat. Aliquam eget malesuada nisi. Etiam mauris neque,
					varius vel blandit non, imperdiet facilisis eros. Aliquam ac
					odio id mi cursus posuere. Nunc in ex nec justo iaculis
					sodales. Donec ullamcorper sem non metus eleifend, sed
					molestie urna egestas. Vestibulum gravida mattis varius.
					Vivamus nec nulla mi. Nulla varius quam in lorem molestie
					posuere.
				</p>
				<h2>Heading 2</h2>
				<h3>Heading 3</h3>
				<h4>Heading 4</h4>
				<h5>Heading 5</h5>
				<h6>Heading 6</h6>
				<h3>Ordered List</h3>
				<ol>
					<li>List Item 1</li>
					<li>List Item 2</li>
					<li>List Item 3</li>
				</ol>
				<h3>Unordered List</h3>
				<ul>
					<li>List Item 1</li>
					<li>List Item 2</li>
					<li>List Item 3</li>
				</ul>
			</div>
		</Fragment>
	);
};

// @ts-ignore
export default Edit;
